import { Flex } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { ListField } from "@/organisms/Form/components/ListField"
import { RESOURCES } from "../ResourcesSectionForm"
import { ResourcesCard } from "./ResourcesCard"

import styles from "./ResourcesList.module.scss"

import type { ResourcesListProps } from "."

export const ResourcesList = (props: ResourcesListProps) => {
  const { SPECIFIC, INITIAL_VALUE } = RESOURCES
  const { fieldName = SPECIFIC, options = { resources: [], fields: {} } } =
    props
  const { isAllResources, disabled = !!isAllResources } = props
  const { t } = useTranslation()
  const buttonProps = isAllResources
    ? undefined
    : {
        disabled,
        className: styles.addButton,
        type: "and" as const,
        initialValues: INITIAL_VALUE
      }

  return (
    <Flex vertical gap={8} data-testid="resources-list-form">
      <ListField
        form={props.form}
        name={fieldName}
        buttonProps={buttonProps}
        componentProps={{ options, t, disabled, isAllResources }}
        render={ResourcesCard}
      />
    </Flex>
  )
}
